import { reactive, onMounted } from "vue";
import { postMatchChampionList } from "@/api/home-page";
import { championRaceTime } from "@/config/homePage";

export function useHomePageChampionShow() {
  const championShowState = reactive({
    raceQuartertype: 10, // 赛季季度类型
    groupType: 1, // 组别类型
    teamInfo: {},
  });
  onMounted(() => {
    championShowState.groupType = getCurrentCampionRace();
    fetchChampionshipList();
  });

  // 筛选已结束且最近的比赛组别
  function getCurrentCampionRace() {
    let current = new Date().getTime();
    let currentRace = championRaceTime[championShowState.raceQuartertype]
      .filter((item) => item.time <= current)
      .sort((a, b) => a - b);
    if (currentRace.length === 3) {
      return 3;
    } else {
      return currentRace?.[0]?.value;
    }
  }
  // 赛季季度切换
  function raceQuarterSwitchFct(val) {
    championShowState.raceQuartertype = val.value;
    fetchChampionshipList();
  }

  // 组别类型切换
  function groupSwitchFct(val) {
    championShowState.groupType = val.value;
    fetchChampionshipList();
  }
  // 获取冠军赛列表
  const fetchChampionshipList = async () => {
    try {
      const res = await postMatchChampionList({
        matchGroup: championShowState.groupType,
        matchSeason: championShowState.raceQuartertype,
        matchSession: 3,
        matchZone: 1,
      });
      if (res.code === 0) {
        let championTeam =
          res.data.list[2] && res.data.list[2][0].victory_match_team_id
            ? res.data.list[2]
            : [];
        console.log("championTeam:", championTeam);
        if (championTeam.length !== 0) {
          championTeam[0].victory_match_team_id ===
          championTeam[0].blue_match_team_id
            ? (championShowState.teamInfo = championTeam[0].blue_match_team)
            : (championShowState.teamInfo = championTeam[0].red_match_team);
        } else {
          championShowState.teamInfo = {};
        }
        return res.data;
      }
    } catch (error) {
      console.warn("获取冠军赛列表失败", error);
    }
    return {};
  };

  return {
    championShowState,
    raceQuarterSwitchFct,
    groupSwitchFct,
  };
}

export default useHomePageChampionShow;
